


import './App.css';
import { Routes, Route } from 'react-router-dom';

import AdminLayout from './Components/AdminLayout/AdminLayout';
import PrivateRoute from './Components/PrivateRoute/PrivateRoute';

import AdminLogin from './Components/Admin/AdminLogin';

function App() {
  return (
    <div className="App">
      <Routes>


        {/* ADMIN PANEL */}


        <Route
          path="/"
          element={
            <PrivateRoute>
            
                <AdminLayout />
    
            </PrivateRoute>
          }
        />
   <Route path="/admin-login" element={<AdminLogin />} />
   
      </Routes>
    </div>
  );
}

export default App;
